import { makeStyles, createStyles, Button } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import {useSelector} from "react-redux"
import { useTranslation } from "react-i18next";
import { useCreateNewVenue } from "../../../hooks/useCreateNewVenue";
import { useVenueSelection } from "../../../hooks/useVenueSelection";
import ILocationAPIObject from "../../../interfaces/ILocationAPI";
import IVenue from "../../../yoello-lib/modules/API/interfaces/IVenue";
import { AlertStatusCard } from "../../../yoello-lib/modules/components/UI/Alerts/AlertStatusCard";
import { ISelectOptions } from "../../../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";
import ListLoading from "../../util/Loading";
import { IReduxAppState } from "../../../reducers";
import { OnboardingSources } from "../types";

interface ICreateVenueProps {
    data: {
        venue_name: string;
        venue_location: ISelectOptions;
        integration_object_id?:string;
    };
    onFinishFunction?: () => void;
    goBack: () => void;
}


const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            textAlign: 'center'
        },
        buttonContainer: {
            display: 'flex',
            flexDirection: 'column',
            position:"absolute",
            bottom:0,
            left:0,
            padding:"1.25rem 3.75rem",
            width:"100%"
        },
    }))


type CreateVenueReturn = {
    location: ILocationAPIObject,
    venue: IVenue
} | null;

export function CreateVenue({
    data,
    onFinishFunction,
    goBack
}: ICreateVenueProps) {
    const { isLoading, createVenue } = useCreateNewVenue();
    const selectVenue = useVenueSelection();
    const { t } = useTranslation();
    const classes = useStyles();
    const [venueData, setVenueData] = useState<CreateVenueReturn>(null);
    const [isError, setIsError] = useState(false);
    const venue_name = venueData?.venue?.venue_name;
    const selectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
    const Venue = useSelector((state: IReduxAppState) => state.venue[selectedVenueId]?.venueData);
    const setting =  useSelector((state: IReduxAppState) => state.venue[selectedVenueId]?.venueSettings);
    const isPay360 = Venue?.payment_processor === "PAY360";
    const isBarclaycard = Venue?.onboarding_source === OnboardingSources.barclaycard;
    const isZeroBubbleLead = Venue?.onboarding_source === OnboardingSources.zerobubble;
    const isBNALead = Venue?.onboarding_source === OnboardingSources.bna;
    const merchant = useSelector((state: IReduxAppState) => state.merchant)

    useEffect(() => {
        const contactEmail = merchant.contact_email ?? undefined;
        const createObj = {
            venue_location: data.venue_location,
            venue_data: isPay360 ? { 
                venue_name: data.venue_name,
                country_code: data.venue_location.value,
                contact_email: contactEmail,
                integration_object_id: data.integration_object_id ?? undefined
            } : { 
                venue_name: data.venue_name,
                country_code: (isZeroBubbleLead || isBNALead) ? undefined : data.venue_location.value,
                integration_object_id: data.integration_object_id ?? undefined 
            },
            venue_setting_data: isBarclaycard ? { acquirer_name:setting?.acquirer_name } : {}
        }

        createVenue(createObj, true , (isZeroBubbleLead || isBNALead)).then((result: unknown) => {
            setVenueData(result as CreateVenueReturn);
        }).catch((e) => setIsError(true));
        // eslint-disable-next-line
    }, []);

    function onClick() {
        if (!venueData) return;
        if (venueData.venue.id) {
            selectVenue(venueData.venue.id);
            if (onFinishFunction) {
                onFinishFunction();
            }
        }
    }

    function render() {
        if (isLoading) {
            return <ListLoading />;
        }
        if (venueData) {
            return <div className={classes.buttonContainer}>
                <Button variant="contained" onClick={onClick} color="default">
                    {t('signup.newVenue.venueCreatedButton')} {venue_name}
                </Button>
                <Button onClick={goBack}>
                    {t('signup.newVenue.venueCreatedBackButton')}
                </Button>
            </div>
        }
        return null;
    }

    return <div>
        {!isError && <p className={classes.root}>{!venueData ? t('signup.newVenue.venueCreation') : t('signup.newVenue.venueCreated')}</p>}
        {render()}
        {isError &&
            <AlertStatusCard alertProps={{ severity: 'error' }} alertMessage={t('signup.newVenue.error')} />
        }
    </div>
}
